import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import NotFound from "pages/NotFound";
import Home1 from "pages/Home1/Home1Page/index";
import PrivPolicy from "pages/Privacy";
import BecomeASeller from "pages/becomeASeller/BecomeASeller";
import AddBusniessDetails from "pages/becomeASeller/AddBusniessDetails";
import Dashboard from "pages/clientDashbaord/dashboard/Dashboard";
import Incoice from "pages/clientDashbaord/dashboard/invoice/Incoice";
import OrderDashbaord from "pages/clientDashbaord/dashboard/order/OrderDashbaord";
import SellarShop from "pages/clientDashbaord/dashboard/sellarShop/SellarShop";
import RatingAndReviews from "pages/clientDashbaord/dashboard/ratingandReviews/RatingAndReviews";
import Notification from "pages/clientDashbaord/dashboard/notification/Notification";
import SupportSeller from "pages/clientDashbaord/dashboard/support/SupportSeller";
import Login from "pages/login/Login";
import { isAuthenticated } from "pages/utils/Utils";
import LoginAdmin from "admin/loginadmin/Loginadmin";
import AdminDashbaord from "admin/adminDashboard/AdminDashboard";
import Pending from "admin/applications/pending/Pending";
import Rejected from "admin/applications/rejected/Rejected";
import Approved from "admin/applications/approved/Approved";
import Customers from "admin/jobHistory/customers/Customers";
import AllCustomers from "admin/jobHistory/customers/AllCustomers";
import CustomerDetailspg from "admin/components/jobhistory/CustomerDetailspg";
import ViewAllBooking from "admin/jobHistory/customers/ViewAllBooking";
import Campanies from "admin/jobHistory/campanies/Campanies";
import ViewAllCompanies from "admin/components/jobhistory/companies/ViewAllCompanies";
import DetailsCompaniesCom from "admin/components/jobhistory/companies/DetailsCom";
import NotVerifiedUser from "pages/login/NotVerifiedUser";
import ServiceCatalog from "admin/serviceCatalog/ServiceCatalog";
import CustomerServiceBuyer from "admin/customerServiceBuyer/CustomerServiceBuyer";
import CustomerSeller from "admin/customerServiceBuyer/CustomerSeller";
import Sendnotifcations from "admin/sendnotification/SendNotification";
import AdminAgent from "admin/agent/Agent";
import AdminSales from "admin/sales/Sales";
import AllCustomersAppRe from "admin/allUsers/allCustomersAppRe/AllCustomersAppRe";
import AllCompaniesAppRe from "admin/allUsers/allCompaniesAppRe/AllCompaniesAppRe";
import DetailsSalePg from "admin/sales/DetailsSalePg";
import AgentLogin from "agentfolder/agentLogin/AgentLogin";
import AgentDashbaord from "agentfolder/agentDashboard/AgentDashboard";
import AgentChatSupport from "agentfolder/agentchatsupport/AgentChatSupport";
import AgentSale from "agentfolder/agentSale/AgentSale";
import AgentEditProfile from "agentfolder/agentEditProfile/AgentEditProfile";
import AllRatingReviews from "pages/clientDashbaord/dashboard/ratingandReviews/AllRatingReviews";
import ServiceFee from "admin/serviceFee/ServiceFee";
import PromoCode from "admin/PromoCode/PromoCode";
import ChatApp from "admin/adminchats/Chats";
import AgentEditScree from "agentfolder/agentEditProfile/AgentEditScree";
import AgentNotification from "agentfolder/notificationpg/Notification";
import AgentChatScreen from "agentfolder/agentchatscreen/AgentChatScreen";
import ForgotPassowrd from "pages/becomeASeller/forgotPassowrd/ForgotPassowrd";
import BecomeAPartner from "pages/Home1/BecomeAPartner";
import TermsOfUse from "pages/TermofUse";
import Account from "pages/clientDashbaord/dashboard/account/Account";
import AllOrders from "admin/order/Order";
import ProviderLanding from "pages/providerLanding/ProviderLanding";
import Crm from "admin/crm/Crm";
import AdminLocations from "admin/location/Location";
import WashCounts from "admin/packages/WashCounts";
import PackageSets from "admin/packages/PackageSets";
import PackageLocations from "admin/packages/PackageLocations";
import PackageOrders from "admin/packages/PackageOrders";
import DueWashes from "admin/packages/DueWashes";
import Packages from "pages/clientDashbaord/packages/Packages";
import Dailyops from "pages/clientDashbaord/dailyops/Dailyops";

const ProjectRoutes = () => {
  const authStatus = isAuthenticated();

  
  const routes = useRoutes([
    { path: "/", element: authStatus === "user" ? <Navigate to="/become-a-seller/dashboard" /> : authStatus === "admin" ? <Navigate to="/super-admin-dashboard/sales" /> : authStatus === "agent" ? <Navigate to="/agent-dashboard" /> : <Home1 /> },
    { path: "/PrivacyPolicy", element: <PrivPolicy /> },
    { path: "/TermsOfUse", element: <TermsOfUse /> },
    { path: "/super-admin-dashboard/sales", element: authStatus === "admin" ? <AdminSales /> : <Navigate to="/" /> },
    { path: "/become-a-seller", element: authStatus === "user" ? <Navigate to="/become-a-seller/dashboard" /> : <BecomeASeller /> },
    { path: "/super-admin-login", element: <LoginAdmin /> },
    { path: "/agent-login", element: <AgentLogin /> },
    { path: "/become-a-partner", element: <BecomeAPartner /> },
    { path: "/forgot-password", element: <ForgotPassowrd /> },
    { path: "/for-providers", element: <ProviderLanding /> },
    
    { path: "/agent-dashboard", element: authStatus === "agent" ? <AgentDashbaord /> : <Navigate to="/agent-login" /> },
    { path: "/agent-dashboard/agent-notification", element: authStatus === "agent" ? <AgentNotification /> : <Navigate to="/agent-login" /> },
    { path: "/agent/agent-chats", element: <ProtectedRoute element={<AgentChatScreen />} authStatus="agent" /> },

    { path: "/agent/agent-edit-profile/edit-profile", element: <ProtectedRoute element={<AgentEditScree />} authStatus="agent" /> },
    { path: "/agent/agent-chat-support", element: <ProtectedRoute element={<AgentChatSupport />} authStatus="agent" /> },
    { path: "/agent/agent-edit-profile", element: <ProtectedRoute element={<AgentEditProfile />} authStatus="agent" /> },
    { path: "/agent/agent-sale", element: <ProtectedRoute element={<AgentSale />} authStatus="agent" /> },
    { path: "/not-verified", element: <NotVerifiedUser /> },
    { path: "/sign-in", element: authStatus === "user" ? <Navigate to="/become-a-seller/dashboard" /> : <Login /> },
    { path: "*", element: <NotFound /> },

    // Protected Routes for Users
    { path: "/become-a-seller/business-details", element: <AddBusniessDetails /> },
    { path: "/become-a-seller/dashboard", element: <ProtectedRoute element={<Dashboard />} authStatus="user" /> },
        { path: "/become-a-seller/packages", element: <ProtectedRoute element={<Packages />} authStatus="user" /> },
    { path: "/become-a-seller/daily-ops", element: <ProtectedRoute element={<Dailyops />} authStatus="user" /> },

     { path: "/become-a-seller/account", element: <ProtectedRoute element={<Account />} authStatus="user" /> },
    { path: "/become-a-seller/notification", element: <ProtectedRoute element={<Notification />} authStatus="user" /> },
    { path: "/become-a-seller/support", element: <ProtectedRoute element={<SupportSeller />} authStatus="user" /> },
    { path: "/become-a-seller/invoices", element: <ProtectedRoute element={<Incoice />} authStatus="user" /> },
    { path: "/become-a-seller/orders", element: <ProtectedRoute element={<OrderDashbaord />} authStatus="user" /> },
    { path: "/become-a-seller/shops", element: <ProtectedRoute element={<SellarShop />} authStatus="user" /> },
    { path: "/become-a-seller/rating-and-reviews", element: <ProtectedRoute element={<RatingAndReviews />} authStatus="user" /> },
    { path: "/become-a-seller/rating-and-reviews/all-rating-reviews", element: <ProtectedRoute element={<AllRatingReviews />} authStatus="user" /> },

    // Protected Routes for Admins/super-admin-dashboard/customers
    { path: "/super-admin-dashboard/promo-code", element: <ProtectedRoute element={<PromoCode />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/CRM", element: <ProtectedRoute element={<Crm />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/Location", element: <ProtectedRoute element={<AdminLocations />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/orders", element: <ProtectedRoute element={<AllOrders />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/chats-screen", element: <ProtectedRoute element={<ChatApp />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/service-fee", element: <ProtectedRoute element={<ServiceFee />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/monthly-packages/wash-counts", element: <ProtectedRoute element={<WashCounts />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/monthly-packages/package-sets", element: <ProtectedRoute element={<PackageSets />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/monthly-packages/locations", element: <ProtectedRoute element={<PackageLocations />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/monthly-packages/orders", element: <ProtectedRoute element={<PackageOrders />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/monthly-packages/due-washes", element: <ProtectedRoute element={<DueWashes />} authStatus="admin" /> },
    { path: "/super-admin-dashboard", element: <ProtectedRoute element={<AdminDashbaord />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/pending", element: <ProtectedRoute element={<Pending />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/rejected", element: <ProtectedRoute element={<Rejected />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/customers", element: <ProtectedRoute element={<Customers />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/customers/all-customers", element: <ProtectedRoute element={<AllCustomers />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/all-users/all-customers", element: <ProtectedRoute element={<AllCustomersAppRe />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/all-users/all-companies", element: <ProtectedRoute element={<AllCompaniesAppRe />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/sales/view-details", element: <ProtectedRoute element={<DetailsSalePg />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/customers/all-customers/customer-details", element: <ProtectedRoute element={<CustomerDetailspg />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/customers/all-customers/customer-details/view-all-bookings", element: <ProtectedRoute element={<ViewAllBooking />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/approved", element: <ProtectedRoute element={<Approved />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/companies", element: <ProtectedRoute element={<Campanies />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/companies/all-companies", element: <ProtectedRoute element={<ViewAllCompanies />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/companies/all-companies/companies-details", element: <ProtectedRoute element={<DetailsCompaniesCom />} authStatus="admin" /> },
    // { path: "/super-admin-dashboard/service-timing", element: <ProtectedRoute element={<ServiceTiming />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/service-catalog", element: <ProtectedRoute element={<ServiceCatalog />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/customer-service-buyer", element: <ProtectedRoute element={<CustomerServiceBuyer />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/customer-service-seller", element: <ProtectedRoute element={<CustomerSeller />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/send-notifications", element: <ProtectedRoute element={<Sendnotifcations />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/add-agents", element: <ProtectedRoute element={<AdminAgent />} authStatus="admin" /> },
    { path: "/super-admin-dashboard/sales", element: <ProtectedRoute element={<AdminSales />} authStatus="admin" /> },
  ]);
  return routes;
};

const ProtectedRoute = ({ element, authStatus }) => {
  const currentAuthStatus = isAuthenticated();

  if (currentAuthStatus && currentAuthStatus === authStatus) {
    return element;
  }

  if (authStatus === "user") {
    return <Navigate to="/sign-in" />;
  }

  if (authStatus === "admin") {
    return <Navigate to="/super-admin-login" />;
  }
  if (authStatus === "agent") {
    return <Navigate to="/agent-login" />;
  }

  return <Navigate to="/" />;
};

export default ProjectRoutes;
